import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import MoneyDisplay from "@/components/feature/MoneyDisplay.vue"
import MenuDropdown, { ActionType } from "@/components/widgets/common/MenuDropdown.vue"
import {
  ConsultantContractPayment,
  ConsultantContractPaymentInput,
  UpdateConsultantContractPaymentMutation,
  UpdateConsultantContractPaymentMutationMutation,
  UpdateConsultantContractPaymentMutationMutationVariables,
  PaymentStateEnum,
  MissionStaffingPositionDetailFragmentFragment,
} from "@/gql"
import { useNotification } from "@/hooks/useNotification"
import { useMutation } from "@/hooks/useMutation"
import ExpansionPanels from "@/components/widgets/accordion/ExpansionPanels.vue"
import ExpansionPanel from "@/components/widgets/accordion/ExpansionPanel.vue"
import ExpansionHeader from "@/components/widgets/accordion/ExpansionHeader.vue"
import ExpansionContent from "@/components/widgets/accordion/ExpansionContent.vue"
import { useMissionLifecycleContext } from "@/modules/Missions/hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantPaymentDetails',
  props: {
    staffingPosition: null
  },
  emits: ["payment:setup", "payment:add", "payment:update"],
  setup(__props: any, { emit: emits }) {





const { addSuccess, addError } = useNotification()
const { mutate } = useMutation()

const { mission } = useMissionLifecycleContext()

const expansionPanelState = ref(0)
const isSubmitting = ref(false)
const showConfirmationDialog = ref(false)
const selectedPayment = ref<ConsultantContractPayment | null>(null)
const actions: ActionType[] = [
  {
    text: "Update payment",
    handler: (payment: ConsultantContractPayment) => {
      emits("payment:update", payment)
    },
  },
  {
    text: "Update status to paid",
    handler: (payment: ConsultantContractPayment) => {
      selectedPayment.value = payment
      showConfirmationDialog.value = true
    },
  },
]

const onUpdatePaymentToPaid = () => {
  if (!selectedPayment.value) return
  onUpdatePayment(selectedPayment.value, {
    state: PaymentStateEnum.Paid,
  })
}

const onAddNewPayment = () => {
  emits("payment:add")
}

const onSetupPayments = () => {
  if (!mission.missionPricingProposal?.totalPrice?.amount) {
    addError("Please setup the mission pricing first")
    return
  }
  emits("payment:setup")
}

const onUpdatePayment = async (
  payment: ConsultantContractPayment,
  paymentInput: ConsultantContractPaymentInput
) => {
  if (!payment.prn) return
  isSubmitting.value = true
  const result = await mutate<
    UpdateConsultantContractPaymentMutationMutation,
    UpdateConsultantContractPaymentMutationMutationVariables
  >({
    mutation: UpdateConsultantContractPaymentMutation,
    variables: {
      consultantContractPaymentId: payment.prn,
      consultantContractPaymentInput: {
        ...paymentInput,
      },
    },
    done: () => {
      isSubmitting.value = false
      showConfirmationDialog.value = false
    },
  })
  if (result?.data && !result?.data?.updateConsultantContractPayment.error) {
    addSuccess("Consultant fees updated successfully")
  }
}

return { __sfc: true,emits, addSuccess, addError, mutate, mission, expansionPanelState, isSubmitting, showConfirmationDialog, selectedPayment, actions, onUpdatePaymentToPaid, onAddNewPayment, onSetupPayments, onUpdatePayment, Icon, MoneyDisplay, MenuDropdown, ExpansionPanels, ExpansionPanel, ExpansionHeader, ExpansionContent }
}

})